// Mock data for Forex Brokers Association

export const winnersData = [
  {
    id: 1,
    year: 2024,
    category: "Best Overall Forex Broker",
    winner: "IG Markets",
    country: "United Kingdom",
    description: "Outstanding performance in trading platforms, customer service, and regulatory compliance.",
    visible: true
  },
  {
    id: 2,
    year: 2024,
    category: "Best Forex Platform",
    winner: "Saxo Bank",
    country: "Denmark",
    description: "Superior trading technology and comprehensive market access.",
    visible: true
  },
  {
    id: 3,
    year: 2024,
    category: "Best Customer Support",
    winner: "Pepperstone",
    country: "Australia",
    description: "Exceptional customer service and support across multiple channels.",
    visible: true
  },
  {
    id: 4,
    year: 2024,
    category: "Best for Algorithmic Trading",
    winner: "IC Markets",
    country: "Australia",
    description: "Leading platform for automated and algorithmic trading solutions.",
    visible: true
  },
  {
    id: 5,
    year: 2024,
    category: "Best FX Research",
    winner: "HSBC",
    country: "United Kingdom",
    description: "Comprehensive market analysis and research capabilities.",
    visible: true
  },
  {
    id: 6,
    year: 2024,
    category: "Best for Professional Trading",
    winner: "Interactive Brokers",
    country: "United States",
    description: "Advanced tools and competitive pricing for professional traders.",
    visible: true
  },
  {
    id: 7,
    year: 2023,
    category: "Best Overall Forex Broker",
    winner: "CMC Markets",
    country: "United Kingdom",
    description: "Excellence in platform innovation and client services.",
    visible: true
  },
  {
    id: 8,
    year: 2023,
    category: "Best Forex Platform",
    winner: "TradeStation",
    country: "United States",
    description: "Innovative trading technology and platform development.",
    visible: true
  },
  {
    id: 9,
    year: 2023,
    category: "Best Mobile Trading App",
    winner: "eToro",
    country: "Cyprus",
    description: "User-friendly mobile platform with social trading features.",
    visible: true
  },
  {
    id: 10,
    year: 2023,
    category: "Best ECN Broker",
    winner: "FP Markets",
    country: "Australia",
    description: "Superior ECN execution and tight spreads.",
    visible: true
  },
  {
    id: 11,
    year: 2024,
    category: "Best FX Options Platform",
    winner: "JP Morgan",
    country: "United States",
    description: "Leading options trading platform with advanced risk management.",
    visible: true
  },
  {
    id: 12,
    year: 2024,
    category: "Best Spot Liquidity Provider",
    winner: "Citadel Securities",
    country: "United States",
    description: "Exceptional liquidity provision and execution quality.",
    visible: true
  },
  {
    id: 13,
    year: 2023,
    category: "Best Institutional Broker",
    winner: "Deutsche Bank",
    country: "Germany",
    description: "Outstanding institutional trading services and support.",
    visible: true
  },
  {
    id: 14,
    year: 2023,
    category: "Best Retail Broker",
    winner: "XTB",
    country: "Poland",
    description: "Excellent retail trading experience and education resources.",
    visible: true
  },
  {
    id: 15,
    year: 2024,
    category: "Best Corporate FX Services",
    winner: "Barclays",
    country: "United Kingdom",
    description: "Superior corporate FX solutions and treasury services.",
    visible: true
  },
  {
    id: 16,
    year: 2024,
    category: "Best Customer Support 2024",
    winner: "GraceXFX",
    country: "Global",
    description: "GraceXFX has been honored with the prestigious 'Best Customer Support 2024' award by the Forex Brokers Association. This accolade recognizes GraceXFX's commitment to delivering exceptional, client-centered support that empowers traders worldwide. Known for their dedication to transparency, innovation, and a personalized trading experience, GraceXFX continues to set new standards in the industry.",
    website: "https://gracexfx.com/",
    visible: false
  },
  {
    id: 17,
    year: 2024,
    category: "Excellence in Trading Services",
    winner: "Saqs Investment",
    country: "Global",
    description: "Saqs Investment recognized for excellence in providing comprehensive trading services and investment solutions to clients worldwide.",
    visible: false
  },
  {
    id: 18,
    year: 2024,
    category: "Innovative Trading Solutions",
    winner: "FXDRIP",
    country: "Global",
    description: "FXDRIP awarded for innovative approach to forex trading solutions and dedication to trader success.",
    visible: false
  }
];

export const faqData = [
  {
    id: 1,
    question: "To Whom Does the FX Global Code Apply?",
    answer: "The FX Market features a diverse set of participants who engage in the market in different ways and across various FX products. The Global Code is written with this diversity in mind and is expected to apply to all FX Market Participants that engage in the FX Markets, including sell-side and buy-side entities, non-bank liquidity providers, operators of E-Trading Platforms, and other entities providing brokerage, execution, and aggregation services. Given the diversity of the market, the Global Code is intended to establish a common set of guidelines for responsible participation in the market."
  },
  {
    id: 2,
    question: "What is the purpose of the Global Code?",
    answer: "The Global Code serves to promote a robust, fair, liquid, open, and appropriately transparent market in which a diverse set of Market Participants can confidently and effectively transact. It identifies global good practices and processes to promote integrity and effective functioning of the wholesale foreign exchange market."
  },
  {
    id: 3,
    question: "How does the FBA ensure ethical standards?",
    answer: "The FBA requires all members to adhere to the highest ethical standards in doing business. We enforce a zero tolerance to corruption policy and promote fair and transparent competition while respecting intellectual and property rights. We encourage compliance with the rule of law at all times."
  },
  {
    id: 4,
    question: "What are the benefits of FBA membership?",
    answer: "FBA members benefit from industry recognition, networking opportunities with leading forex brokers, access to exclusive resources and research, regulatory advocacy, and protection of collective interests on a nation-wide scale. Members also gain credibility through association with ethical business practices."
  },
  {
    id: 5,
    question: "How are award winners selected?",
    answer: "Award winners are selected through a rigorous evaluation process that considers multiple factors including trading platform quality, customer service excellence, regulatory compliance, innovation, market execution quality, and overall contribution to the forex industry. Our independent panel of experts reviews all submissions and market data."
  },
  {
    id: 6,
    question: "Is the Global Code legally binding?",
    answer: "The Global Code does not impose legal or regulatory obligations on Market Participants nor does it substitute for regulation. Rather, it is intended to serve as a supplement to any and all local laws, rules, and regulations by identifying global good practices and processes."
  }
];

export const missionValues = [
  {
    id: 1,
    title: "TRANSPARENCY",
    description: "All FBA members adhere to the highest ethical standards in doing business. We respect and follow a zero tolerance to corruption policy.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "RULE OF LAW",
    description: "We promote fair and transparent competition, respect intellectual and other property rights. We encourage compliance with the rule of law at all times.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "RELATIONSHIP",
    description: "We respect and promote fair, open and meaningful relationships between business and the government and between our members.",
    icon: "Users"
  },
  {
    id: 4,
    title: "CULTURE AND RESPECT",
    description: "People are our greatest asset – we say it often and with good reason. We care for people. We have a burning passion for talent. We respect human rights, health, safety and equal opportunities at work.",
    icon: "Heart"
  },
  {
    id: 5,
    title: "SECURITY AND CARE",
    description: "We do our best to protect our members' interests – individual or collective – on the highest nation-wide scale. We nurture meaningful relations with the government to assure our members are protected and safeguarded.",
    icon: "Lock"
  },
  {
    id: 6,
    title: "PASSION FOR INNOVATION",
    description: "We are smart and proactive. Every single day we think creatively to turn ideas into tangible results.",
    icon: "Zap"
  }
];